import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

import LoginPage from './pages/login/LoginPage';
import ProloguePage from './pages/prologue/ProloguePage';
import CheckListPage from './pages/checkList/CheckListPage';
import ByFaithPage from './pages/byFaith/ByFaithPage';
import RhemaPage from './pages/rhema/RhemaPage';
import MyRhemaPage from './pages/myRhema/MyRhemaPage';
import MyFaithPage from './pages/myFaith/MyFaithPage';
import EpiloguePage from './pages/epilogue/EpiloguePage';
import FaithPage from './pages/faith/FaithPage'
import NotePage from './pages/note/NotePage';



import './index.css'

// 🔥 인앱 브라우저 감지 후 기본 브라우저로 강제 이동
(function redirectToExternalBrowser() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;

  if (/FBAN|FBAV|Instagram|KAKAOTALK/i.test(ua)) {
    var inappdeny_exec_vanillajs=e=>{"loading"!==document.readyState?e():document.addEventListener("DOMContentLoaded",e)};inappdeny_exec_vanillajs((()=>{var e=navigator.userAgent.toLowerCase(),a=window.location.href;e.match(/kakaotalk/i)&&(window.location.href="kakaotalk://web/openExternal?url="+encodeURIComponent(a))}))
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/checkList" element={<CheckListPage />} />
      <Route path="/byFaith" element={<ByFaithPage />} />
      <Route path="/rhema" element={<RhemaPage />} />
      <Route path="/myRhema/:id" element={<MyRhemaPage />} />
      <Route path="/myFaith" element={<MyFaithPage />} />
      <Route path="/note" element={<NotePage />} />
      
      <Route path="/faith" element={<FaithPage />} />
      <Route path="/prologue" element={<ProloguePage />} />
      <Route path="/epilogue" element={<EpiloguePage />} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
